// Shared brand library — used across Add Custom Item, Add Release (admin),
// Suggest Release (community), and Catalog filters.
// Popular kept at top, rest alphabetized. Users can free-type a brand not in the list.
export const BRANDS = [
  "Hot Wheels", "Tarmac Works", "Tomica", "Inno64", "Mini GT", "Kaido House",
  "Almost Real", "AT Model", "Auto World", "BM Creations", "BMC", "BSC",
  "Cartuned", "CM Model", "CoolCar", "DCM", "Decode", "Demon King", "DM Model",
  "Fast & Speed", "FinClassically", "Fine Works 64", "Flame", "Focal Horizon",
  "GCD", "GreenLight", "Hobby Japan", "Hone Model", "Ignition Model",
  "IXO America", "IXO Model", "Johnny Lightning", "KiloWorks", "King Model",
  "Liberty64", "LMF", "M2 Machines", "Majorette", "Matchbox", "Mega Gear",
  "MicroTurbo", "MiniChamps64", "Model Model", "MoreArt", "Mortal Model",
  "MotorHelix", "My Model Collect", "Norve", "PGM", "Pop Race", "Rhino Model",
  "Schuco", "Stance Hunter", "Star Model", "Street Warrior", "Street Weapon",
  "Supercar", "TCP", "TimeMicro", "TimeMicro X PSC Design", "Tomy", "TopArt",
  "Trends Hobby", "TSM", "Zincit Model",
  "Other",
];

// Brands where the "BLKLTD" toggle is meaningful (Black Limited is a Kaido House sub-line)
export const BRANDS_WITH_BLKLTD = ["Kaido House", "Kaido House x Mini GT"];

export function brandHasBlkltd(brand) {
  if (!brand) return false;
  const lower = brand.toLowerCase();
  return lower.includes("kaido house");
}
